const nexusConfig = window.NEXUS_CONFIG || {};
const nexusBaseUrl = nexusConfig.baseUrl || null;
const clientIdToken = nexusConfig.clientIdToken || null;
const clientName = nexusConfig.clientName || null;
const clientType = nexusConfig.clientType || null;
const multipassApiUrl = nexusConfig.multipassApiUrl || null;

function createOverlay() {
    const overlay = document.createElement("div");
    overlay.id = "login-overlay";
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(255,255,255,0.95);
      z-index: 9999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 20px;
    `;

    overlay.innerHTML = `
      <!-- Spinner -->
      <div class="spinner"></div>

      <!-- Status Message -->
      <p class="status-message" style="margin-top:15px;font-weight:500;">
        Logging you in…
      </p>

      <!-- Error Message -->
      <div class="error-box" style="
        display:none;
        color:#b91c1c;
        font-weight:500;
      ">
        &#10060; Login failed. Please try again.
      </div>

      <!-- Retry Button -->
      <button class="retry-btn" style="
        display:none;
        padding:10px 18px;
        font-size:14px;
        cursor:pointer;
      ">
        Retry Login
      </button>

      <!-- ALWAYS VISIBLE WARNING -->
      <p class="warning" style="
        font-size:13px;
        color:#6b7280;
      ">
        &#9888; Please do not refresh this page.
      </p>

      <style>
        .spinner {
          width: 45px;
          height: 45px;
          border: 4px solid #e5e7eb;
          border-top: 4px solid #000;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    `;

    document.body.appendChild(overlay);
    return overlay;
}

async function callMultipass(jwt, overlay, redirectUrl) {
    const spinner = overlay.querySelector(".spinner");
    const status = overlay.querySelector(".status-message");
    const errorBox = overlay.querySelector(".error-box");
    const retryBtn = overlay.querySelector(".retry-btn");

    // ---- Loading State ----
    spinner.style.display = "block";
    status.style.display = "block";
    status.innerText = "Logging you in…";
    errorBox.style.display = "none";
    retryBtn.style.display = "none";

    if (!multipassApiUrl) {
        console.error("Multipass API URL is not configured.");
        overlay.querySelector(".spinner").style.display = "none";
        overlay.querySelector(".status-message").innerText = "Login service not configured.";
        return;
    }

    try {
        const response = await fetch(
            multipassApiUrl,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwt}`
                },
                body: JSON.stringify({ redirectUrl }),
            }
        );

        if (!response.ok) throw new Error("Lambda failed");

        const result = await response.json();
        if (!result?.redirectUrl) throw new Error("Redirect missing");

        status.innerText = "Redirecting… please wait.";
        window.location.href = result.redirectUrl;
    } catch (err) {
        console.error("Multipass error:", err);

        // ---- Error State ----
        spinner.style.display = "none";
        status.style.display = "none";
        errorBox.style.display = "block";
        retryBtn.style.display = "inline-block";
    }
}

document.addEventListener("DOMContentLoaded", () => {

    /*
     Shopify URLs often have ?return_url and after scanning the QR code,
     Nexus returns ?data in the URL. This can result in multiple '?' in the URL.
     To fix this, we replace extra '?' with '&' so URLSearchParams can parse it.
   */
    // Get everything after the first '?'
    const href = window.location.href;

    // Fix multiple '?' issue
    const query = href.split("?").slice(1).join("&");
    const params = new URLSearchParams(query);

    let jwt = params.get("data");
    let returnUrl = params.get("return_to");
    let checkoutUrl = params.get("checkout_url");

    // Decode URLs
    if (returnUrl) returnUrl = decodeURIComponent(returnUrl);
    if (checkoutUrl) checkoutUrl = decodeURIComponent(checkoutUrl);

    // Extract nested data (if inside return_url)
    if (!jwt && returnUrl?.includes("data=")) {
        jwt = new URLSearchParams(returnUrl.split("?")[1]).get("data");
    }

    // Decide redirect
    let redirectUrl =
        checkoutUrl ||
        (returnUrl ? returnUrl.split("?")[0] : "/account");

    if (!jwt) return;


    // Remove JWT from URL immediately
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete("data");
    history.replaceState({}, document.title, cleanUrl.toString());

    const overlay = createOverlay();

    overlay.querySelector(".retry-btn").onclick = () => {
        callMultipass(jwt, overlay, redirectUrl);
    };

    callMultipass(jwt, overlay, redirectUrl);
});

function redirectToNexus() {
    const currentUrl = window.location.href;
    try {
        const url = new URL(nexusBaseUrl);
        const basePath = url.pathname.replace(/\/+$/, "");
        url.pathname = `${basePath}/${encodeURIComponent(clientType)}/${encodeURIComponent(clientName)}/onboard`;
        url.searchParams.set("clientIdToken", clientIdToken);
        url.searchParams.set("clientType", clientType);
        url.searchParams.set("callbackUrl", currentUrl);
        window.location.href = url.toString();
    } catch (e) {
        console.error("Invalid nexusBaseUrl in NEXUS_CONFIG", e);
    }
    if (!nexusBaseUrl || !clientType || !clientName || !clientIdToken) {
        console.error("NEXUS_CONFIG incomplete");
        return;
    }
}